import { mapActions, mapState } from 'pinia'

import { accountSections } from 'src/components/navigation/account.js'
import { navFilterContext } from 'src/components/navigation/filter.js'
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'

import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useInterfaceStore } from 'src/stores/interface'
import { useShoutStore } from 'src/stores/shout'
import { useUsersStore } from 'src/stores/users.js'

import { confirmLogout } from 'src/services/confirm/confirm.js'

// The account menu's entries, for the desktop pop-up and the phone's side
// menu. Emits done after a click, so that the holder can close.
export default {
  components: { NavigationEntry },
  props: {
    place: { type: String, required: true },
  },
  emits: ['done'],
  computed: {
    ...mapState(useUsersStore, ['currentUser']),
    ...mapState(useInstanceCapabilitiesStore, ['suggestionsEnabled']),
    ...mapState(useShoutStore, ['joined']),
    sections() {
      return accountSections(
        {
          place: this.place,
          shout: this.joined,
          suggestions: this.suggestionsEnabled,
          isAdmin: this.currentUser?.role === 'admin',
        },
        navFilterContext(),
      )
    },
  },
  methods: {
    ...mapActions(useInterfaceStore, ['openSettingsModal']),
    run({ action }) {
      this.$emit('done')
      if (action === 'settings') this.openSettingsModal('user')
      if (action === 'admin') this.openSettingsModal('admin')
      if (action === 'logout') this.logout()
    },
    async logout() {
      if (!(await confirmLogout(this.$t))) return
      await useUsersStore().logout()
      this.$router.replace('/main/public')
    },
  },
}
